const prebidService = require('./prebidService'),
	pubsub = require('../utils/pubsub');

function init(config) {
	performance.mark('advert - prebid - initialisation - start');

	pubsub.subscribe('extendSlots', (slots) => {
		return prebidService.getBids(config, slots).catch((err) => {
			console.error('[ADVERT] Something went wrong getting prebid bids.', err);
		});
	});

	performance.mark('advert - prebid - initialisation - end');
}

module.exports = {
	init
};
